import type { GameService } from './types'
import { setsLegsFieldValidator } from '@/utils/setsLegsValidation'

const game: GameService = {
    name: 'x01',
    category: 'classic',
    placeholder: false,
    disable: true,
    onlineAvailable: true,
    form: [
        {
            fields: [
                {
                    component: 'select',
                    key: 'win_type',
                    options: [
                        { value: 'best_of', labelKey: 'match_settings.best_of' },
                        { value: 'first_to', labelKey: 'match_settings.first_to' },
                    ],
                },
                {
                    component: 'select',
                    key: 'starting_score',
                    options: [101, 301, 501, 701, 1001].map((value) => ({
                        value,
                        label: String(value),
                    })),
                },
                {
                    component: 'sets-legs',
                    validate: setsLegsFieldValidator,
                },
                {
                    component: 'select',
                    key: 'check_in',
                    options: [
                        { value: 'single', labelKey: 'match_settings.straight_in' },
                        { value: 'double', labelKey: 'match_settings.double_in' },
                        { value: 'master', labelKey: 'match_settings.master_in' },
                    ],
                },
                {
                    component: 'select',
                    key: 'check_out',
                    options: [
                        { value: 'single', labelKey: 'match_settings.straight_out' },
                        { value: 'double', labelKey: 'match_settings.double_out' },
                        { value: 'master', labelKey: 'match_settings.master_out' },
                    ],
                },
                // "Include in stats" is rendered once, universally, by MatchSetupView's
                // static footer toggle — not per-game, so it isn't listed here.
            ],
        },
    ],
    content: {
        type: 'x01',
        duration: [30, 60],
        difficulty: 'beginner',
        player_count: '1 - 4',
        images: {
            banner: '',
            tile: '',
        },
    },
}

export default game
